import clsx from 'clsx'

export const Blades = ({ className, ...props }: JSX.HTMLAttributes<SVGSVGElement>) => (
  <svg
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 85 85"
    className={clsx('absolute stroke-current', className)}
    {...props}>
    <path
      d="M36.455 1.56v26.626a6.392 6.392 0 0 0 6.138 6.201 6.393 6.393 0 0 0 6.169-6.2c0-9.11-3.58-26.627-12.307-26.627ZM10.148 68.429l23.078-13.33a6.393 6.393 0 0 0 2.27-8.406 6.392 6.392 0 0 0-8.439-2.237c-7.895 4.539-21.288 16.397-16.91 23.973ZM81.205 57.752 58.127 44.455a6.202 6.202 0 0 0-8.407 2.237 6.201 6.201 0 0 0 2.27 8.407c7.894 4.57 24.867 10.133 29.215 2.653Z"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
)
